// extracted by mini-css-extract-plugin
export var scrollArea = "_nw-0";